/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {DriverObject} from "../models/driver-object";
import {DriverObjectService} from "../services/driver-object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class DriverObjectsResolver implements Resolve<DriverObject[]> {

  constructor(
    private mDriverObjectService: DriverObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<DriverObject[]> {
    try {
      return await this.mDriverObjectService.getAllDriverObjects();
    } catch (error) {
      console.error("Problem resolving Driver Objects... Error: " + error, error);
    }
  }

}
